import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table
} from 'reactstrap';
import $ from 'jquery';
import FileBase64 from 'react-file-base64';
import moment from 'moment';
import AppPage from '../../views/AppPage/'
import CKEditor from 'ckeditor4-react';
const GLOBAL = require('../../Globals');

class EditEvent extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			id: '',
			evename: '',
			evetype: '',
			value: '',
			edate: '',
			etime: '',
			_message: '',
			alertClass: '',
			posts: [],
			type: [],
			files: [],
		}
		this.onBack = this.onBack.bind(this);
		this.updateContent = this.updateContent.bind(this);
		this.onChange = this.onChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onShowAppChange = this.onShowAppChange.bind(this);
	}

	onBack(e) {

		this.setState({ _redirect: true });
	}

	updateContent(evt) {
		var newContent = evt.editor.getData();
		this.setState({
			content: newContent
		})
	}

	onShowAppChange(e) {

		if (e.target.checked) {

			this.state.showapp = 1;
		}
		else {

			this.state.showapp = 0;
		}
	}

	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
	}

	/** set value to react-html editor content **/
	handleChange(value) {

		this.setState({ value });
		this.setState({ content: this.state.value.toString('html') });
	}

	//base64 photo
	getFiles(files) {
		this.setState({ files: files })
	}

	onSubmit(e) {
		e.preventDefault();
		$("#showLoader").show();
		PostData('event/editevent', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				this.setState({
					_message: 'Event Updated Successfully!..',
					alertClass: 'alert alert-success'
				});
				this.getdetails();
			}
			else {

				this.setState({
					_message: 'Invalid Key',
					alertClass: 'alert alert-danger'
				});
			}
		});
	}

	componentWillMount() {

		this.getdetails();
		this.getetype();
	}

	/** get Hostel Type **/
	getetype() {

		GetData('event/geteventtype').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					type: responseJson
				});
			}
		});
	}

	getdetails() {
		$("#showLoader").show();
		GetData('event/geteventbyid/' + this.props.match.params.id).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if (res) {
				this.setState({
					evename: res[0]['eventname'],
					content: res[0]['content'],
					edate: res[0]['eventdate'],
					etime: res[0]['eventtime'],
					evetype: res[0]['type'],
					showapp: res[0]['isapp'],
					url: res[0]['image']
				});
			}
		});
	}

	checktime(time) {

		var dt = moment(time, ["h:mm a"]).format("HH:mm");
		return dt;
	}

	render() {

		var items = this.state.type;
		this.state.id = this.props.match.params.id;

		if (this.state.showapp == 1) {

			$("#isapp").prop("checked", true);
		}
		else {

			$("#isapp").prop("checked", false);
		}

		if (this.state._redirect) {

			return (<Redirect to={'/events/event'} />);
		}

		return (
			<div>
				<AppPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<form action="" method="post" role="form" id="eveform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<Row>
							<Col md="12">
								<Card>
									<CardHeader>
										<strong>Edit Event</strong>
										<Button outline color="primary" className="btn-right" onClick={this.onBack}>Back</Button>
									</CardHeader>
									<CardBody>
										<Row>
											<Col md="4">
												<FormGroup>
													<Label htmlFor="name">Event Name <span className="text-danger">*</span></Label>
													<Input type="text" name="evename" required onChange={this.onChange} value={this.state.evename} />
												</FormGroup>
											</Col>
											<Col md="3">
												<FormGroup>
													<Label htmlFor="name">Event Type <span className="text-danger">*</span></Label>
													<select name="evetype" onChange={this.onChange} className="form-control" value={this.state.evetype} >
														<option value="">Select Type</option>
														{
															items.map(function (item) {
																return <option value={item.id}>{item.type}</option>;
															})
														}
													</select>
												</FormGroup>
											</Col>
											<Col md="3">
												<FormGroup>
													<Label htmlFor="name">Event Date <span className="text-danger">*</span></Label>
													<Input type="date" name="edate" required onChange={this.onChange} value={this.state.edate} />
												</FormGroup>
											</Col>
											<Col md="2">
												<FormGroup>
													<Label htmlFor="name">Event Time</Label>
													<Input type="time" name="etime" onChange={this.onChange} value={this.checktime(this.state.etime)} />
												</FormGroup>
											</Col>
											<Col md="9">
												<FormGroup>
													<Label htmlFor="name">About the event <span className="text-danger">*</span></Label>
													<CKEditor
														data={this.state.content}
														onChange={this.updateContent}
														config={{ extraPlugins: 'iframe', extraAllowedContent: '*(*);*{*}', allowedContent: true }}
													/>
												</FormGroup>
											</Col>
											<Col md="3">
												<FormGroup>
													<Label htmlFor="name">Event Photo</Label>
													<Card>
														<CardBody>
															<img src={this.state.url} width="100" height="80" />
														</CardBody>
													</Card>
													<FileBase64 onDone={this.getFiles.bind(this)} />
													<input type="checkbox" id="isapp" name="showapp" onChange={this.onShowAppChange} />&nbsp;&nbsp;Show On App
								</FormGroup>
											</Col>
										</Row>
									</CardBody>
									<CardFooter>
										<Button type="submit" size="sm" className="btn-right" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
									</CardFooter>
								</Card>
							</Col>
						</Row>
					</form>
				</div>
			</div>
		)
	}
}

export default EditEvent;


// WEBPACK FOOTER //
// ./src/events/Event/EditEvent.js